export default "__VITE_PUBLIC_ASSET__da1549ff__"